import {
  GET_FILTERED_SUPPLIER_RECORDS_REQUESTED,
  GET_FILTERED_SUPPLIER_RECORDS_FAILED,
  GET_FILTERED_SUPPLIER_RECORDS_SUCCESS,
  CLEAR_FILTERED_SUPPLIER_RECORDS_ERROR,
} from '../actions/actionTypes';

const initialState = {
  loading: false,
  error: null,
  data: null,
};

const supplierRecordsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FILTERED_SUPPLIER_RECORDS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_FILTERED_SUPPLIER_RECORDS_FAILED:
      return {
        ...state,
        loading: false,
        error: action?.payload?.error,
      };
    case GET_FILTERED_SUPPLIER_RECORDS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action?.payload?.data,
      };
    case CLEAR_FILTERED_SUPPLIER_RECORDS_ERROR:
      return { ...state, error: null };
    default:
      return state;
  }
};

export default supplierRecordsReducer;
